import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MED_FLOW, MED_SKU } from "src/utils/medEligibility";
import { SaleItemInfo } from "./checkoutOrders";
import getStore from "../store";

type RecommendationContextState = {
  recommendedMedTier?: MED_SKU;
  eligibleMedTiers?: Array<MED_SKU>;
  eligibleSaleItems?: Array<SaleItemInfo>;
  flow?: MED_FLOW;
  recommendationId?: string;
};

const initialState: RecommendationContextState = {};

const recommendationContextSlice = createSlice({
  name: "recommendationContext",
  initialState,
  reducers: {
    setRecommendationContext(
      state,
      action: PayloadAction<RecommendationContextState>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setRecommendationContext } = recommendationContextSlice.actions;

export default recommendationContextSlice;

export function setPlansInRecommendationContext(
  recommendedMedTier: MED_SKU,
  eligibleMedTiers: Array<MED_SKU>,
  flow: MED_FLOW,
  recommendationId?: string
) {
  getStore().dispatch(
    setRecommendationContext({
      recommendedMedTier,
      eligibleMedTiers,
      flow,
      recommendationId,
    })
  );
}
